import { isBodyInit } from './isBodyInit';

interface PrepareBodyResult {
  body?: BodyInit;
  headers: Headers;
}

export const prepareBody = (
  bodyInput: unknown,
  headersInit?: HeadersInit
): PrepareBodyResult => {
  const headers = new Headers(headersInit);

  if (bodyInput == null) {
    return { headers };
  }

  // FormData → browser sets content-type automatically
  if (bodyInput instanceof FormData) {
    return {
      headers,
      body: bodyInput,
    };
  }

  // Already valid BodyInit
  if (isBodyInit(bodyInput)) {
    return {
      headers,
      body: bodyInput,
    };
  }

  // Object → JSON
  headers.set('Content-Type', 'application/json');

  return {
    headers,
    body: JSON.stringify(bodyInput),
  };
};
